import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=b119f042&scoped=true"
import script from "./AddressInfo.vue?vue&type=script&lang=js"
export * from "./AddressInfo.vue?vue&type=script&lang=js"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=b119f042&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b119f042",
  null
  
)

export default component.exports